
function loadJs(src: string, id: string, defer = true, async = false): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const existingJsNode = document.getElementById(id) as HTMLScriptElement
    if (existingJsNode) {
      if (existingJsNode.src === src) {
        return
      }
      existingJsNode.id = `${id}-previous`
    }
    const jsNode = document.createElement('script') as HTMLScriptElement
    jsNode.id = id
    jsNode.type = 'text/javascript'
    jsNode.src = src
    // using defer instead of async to guarantee order
    jsNode.defer = defer
    jsNode.async = async
    jsNode.charset = 'utf-8' // TT-12459
    jsNode.onload = () => resolve(true)
    jsNode.onerror = e => reject(e)
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(jsNode)
  })
}

export default loadJs
